const findAndSortIndexesOfCookie = () => {
  const cookies = document.cookie.split(';');

  const zpyInitIndexes = cookies
    .filter((cookie) => cookie.includes('zpy_init'))
    .map((cookie) => cookie.split('=')[0])
    .filter((cookieName) => cookieName !== undefined)
    .map((cookieName) => cookieName?.split('_')[2])
    .filter((cookieIndex) => cookieIndex !== undefined)
    .map((cookieIndex) => Number.parseInt(cookieIndex!))
    .sort((a, b) => b - a);

  return zpyInitIndexes;
};

export const cleanUpSoftpayCookies = () => {
  const indexes = findAndSortIndexesOfCookie();
  const highestIndex = indexes[0];
  const lowestIndex = indexes[indexes.length - 1];

  if (!highestIndex || !lowestIndex) {
    return;
  }

  for (let i = lowestIndex + 5; i <= highestIndex - 5; i++) {
    document.cookie = `zpy_init_${i}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
};
